<template>
	<div class="nav-wrapper">
		<ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
			<li class="nav-item">
				<router-link class="nav-link mb-sm-3 mb-md-0" data-toggle="tab" to="/admin" role="tab" aria-controls="admin-home" aria-selected="true"><i class="ni ni-badge mr-2"></i>Home</router-link>
			</li>
			<li class="nav-item">
				<router-link class="nav-link mb-sm-3 mb-md-0" data-toggle="tab" to="/admin/users" role="tab" aria-controls="admin-users" aria-selected="false"><i class="fas fa-user-shield mr-2"></i>Users</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
  export default {
    name: "AdminMenu"
  };
</script>
<style>
</style>
